import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {BaseModel} from '../models/BaseModel';
import {ReportInfoResponse} from '../models/grantApplication/grantApplicationReportModel';
import {ApplicationFileInfo} from '../models/grantApplication/grantApplicationResponse';

@Injectable({
  providedIn: 'root'
})
export class GrantApplicationReportService {
  private apiUrl = environment.apiConfig.uri+ '/api/grantapplicationreport';

  constructor(private http: HttpClient) { }

  getReportInfo(reportId: string): Observable<BaseModel<ReportInfoResponse>> {
    return this.http.get<BaseModel<ReportInfoResponse>>(`${this.apiUrl}/getinfo/${reportId}`);
  }

  submitReport(formData: any): Observable<BaseModel<any>> {
    return this.http.post<BaseModel<any>>(`${this.apiUrl}/submit`, formData);
  }

  saveDraftReport(formData: any): Observable<BaseModel<any>> {
    return this.http.post<BaseModel<any>>(`${this.apiUrl}/savedraft`, formData);
  }


  uploadDocument(formData: any): Observable<BaseModel<any>> {
    return this.http.post<BaseModel<any>>(`${this.apiUrl}/uploaddocument`, formData);
  }
}
